import { useState, useEffect } from "react";
import { Configuration } from "src/types/configuration";
import RequestService from "src/services/requestService";

const useInitialConfiguration = (
  isLoaded: boolean,
  request: RequestService,
  onInit: (config: Configuration) => void
) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized && isLoaded) {
      const fetchConfiguration = async () => {
        try {
          const response = await request.getOffer();

          if (!response) {
            return;
          }

          const config = response.data?.configuration;

          if (!config) {
            return;
          }

          try {
            const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
            let json = config;

            if (base64Regex.test(config)) {
              json = atob(config);
            }

            const parsedConfig = JSON.parse(json) as Configuration;
            console.log(parsedConfig);

            onInit(parsedConfig);
          } catch (e) {
            console.error("Failed to parse configuration JSON:", e);
          }
        } catch (e) {
          console.error("Failed to load configuration:", e);
        }
      };

      fetchConfiguration().then(() => {
        setIsInitialized(true);
      });
    }
  }, [isInitialized, onInit]);
};

export default useInitialConfiguration;
